import React, { useState, useEffect } from 'react';
import { collection, onSnapshot, deleteDoc, doc, writeBatch } from 'firebase/firestore';
import { db } from '../../firebase';
import * as XLSX from 'xlsx';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Popupinquiry = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch inquiries in real-time from the correct collection
  useEffect(() => {
    if (Notification.permission !== 'granted') {
      Notification.requestPermission();
    }

    const unsubscribe = onSnapshot(
      collection(db, 'popup_contacts'), // Correct collection
      (snapshot) => {
        const inquiryData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setInquiries(inquiryData);
        setLoading(false);

        // Notify only for newly added inquiries
        if (Notification.permission === 'granted' && snapshot.docChanges().some(change => change.type === "added")) {
          new Notification('New Inquiry Received!', {
            body: 'You have a new inquiry. Check your dashboard.',
          });
          toast.info('New inquiry received!');
        }
      },
      (error) => {
        console.error('Error fetching inquiries:', error);
        toast.error('Failed to fetch inquiries');
      }
    );

    return () => unsubscribe(); // Cleanup on unmount
  }, []);

  // Delete a single inquiry
  const deleteInquiry = async (id) => {
    try {
      const docRef = doc(db, 'popup_contacts', id);
      await deleteDoc(docRef);
      setInquiries(inquiries.filter((inquiry) => inquiry.id !== id));
      toast.success('Inquiry deleted successfully!');
    } catch (error) {
      console.error('Error deleting inquiry:', error);
      toast.error('Error deleting inquiry');
    }
  };

  // Delete all inquiries after confirmation
  const deleteAllInquiries = async () => {
    const confirmDelete = window.confirm('Are you sure you want to delete all inquiries?');
    if (confirmDelete) {
      try {
        const batch = writeBatch(db);
        inquiries.forEach((inquiry) => {
          const docRef = doc(db, 'popup_contacts', inquiry.id);
          batch.delete(docRef);
        });
        await batch.commit();
        setInquiries([]);
        toast.success('All inquiries deleted successfully!');
      } catch (error) {
        console.error('Error deleting all inquiries:', error);
        toast.error('Error deleting all inquiries');
      }
    }
  };

  // Export inquiries as Excel file
  const exportToExcel = () => {
    if (inquiries.length === 0) {
      toast.warn('No inquiries to export!');
      return;
    }
    const ws = XLSX.utils.json_to_sheet(inquiries);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Inquiries');
    XLSX.writeFile(wb, 'Inquiries.xlsx');
    toast.success('Excel file downloaded successfully!');
  };

  return (
    <div className="receiveInquiry">
      {/* Toast container for alerts */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <h1 className="dashboardTitle">Received Inquiries</h1>

      {/* Buttons for Export and Delete All */}
      <div className="buttonGroup">
        <button className="exportBtn" onClick={exportToExcel}>
          Download as Excel
        </button>
        <button className="deleteAllBtn" onClick={deleteAllInquiries}>
          Delete All
        </button>
      </div>

      {/* Inquiry Table */}
      {loading ? (
        <p>Loading...</p>
      ) : inquiries.length === 0 ? (
        <p>No inquiries found.</p>
      ) : (
        <table className="inquiryTable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone Number</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {inquiries.map((inquiry) => (
              <tr key={inquiry.id}>
                <td>{inquiry.name}</td>
                <td>{inquiry.phoneNumber}</td>
                <td>
                  <button className="deleteBtn" onClick={() => deleteInquiry(inquiry.id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Popupinquiry;
